import { ChangeDetectionStrategy, Component } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FieldType, FormlyModule } from '@ngx-formly/core';
import { FuseAlertComponent } from '@fuse/components/alert';
import { FormlyErrorComponent } from '../formly-error.component';
import { MatHint } from '@angular/material/form-field';

@Component({
  selector: 'formly-field-fuse-alert',
  standalone: true,
  imports: [CommonModule, FuseAlertComponent, FormlyModule, FormlyErrorComponent, MatHint],
  template: `
    <div class="mb-2">
      <fuse-alert
        [type]="props.alert?.type || 'info'"
        [appearance]="props.alert?.appearance || 'soft'"
        [showIcon]="props.alert?.showIcon !== false"
        [dismissible]="props.alert?.dismissible === true"
        [dismissed]="props.alert?.dismissed === true"
        [name]="field.id">
        @if (props.label && props.hideLabel !== 'true') {
          <span fuseAlertTitle>
            {{ props.label }}
          </span>
        }
        {{ props.alert?.content !== undefined ? props.alert?.content : formControl.value || '' }}
      </fuse-alert>
      @if (props.description) {
        <mat-hint class="inline-block mb-2">{{ props.description }}</mat-hint>
      }
      @if (field.formControl.errors) {
        <app-formly-error [field]="field"></app-formly-error>
      }
    </div>
  `,
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class FormlyFuseAlertComponent extends FieldType<any> {}
